import { DESTINATIONS } from '../../constants/journey';

export const resolveStations = (configuredStations) => {
  const configured = Array.isArray(configuredStations) ? configuredStations.filter((station) => station?.tokenId) : [];
  if (!configured.length) return DESTINATIONS;
  return DESTINATIONS.map((fallback) => {
    const station = configured.find((item) => item.id === fallback.id || item.tokenId === fallback.tokenId);
    return station
      ? { ...fallback, ...station, threshold: Number(station.mcapUsd ?? fallback.threshold) }
      : fallback;
  });
};

export const getActualStationIndex = (state, stations = DESTINATIONS) => {
  const backendIndex = Number(state?.currentStationIndex);
  if (Number.isFinite(backendIndex)) return Math.max(0, Math.min(stations.length, backendIndex));
  const routeProgress = Number(state?.routeProgress) || 0;
  let index = 0;
  stations.forEach((station, stationIndex) => {
    const progress = Number(station.routeProgress ?? station.progress) || 0;
    if (routeProgress + 1e-9 >= progress) index = stationIndex + 1;
  });
  return index;
};

export const getLivePressure = (state, stations = DESTINATIONS) => {
  const actualStationIndex = getActualStationIndex(state, stations);
  if (actualStationIndex >= stations.length) return 1;
  const currentMcap = Number(state?.currentMcapUsd);
  if (!Number.isFinite(currentMcap) || currentMcap < 0) return 0;
  const lower = actualStationIndex === 0 ? 0 : Number(stations[actualStationIndex - 1]?.threshold) || 0;
  const upper = Number(stations[actualStationIndex]?.threshold) || lower;
  if (upper <= lower) return 0;
  return Math.max(0, Math.min(1, (currentMcap - lower) / (upper - lower)));
};

export const getLiveRailwayState = (state, stations = DESTINATIONS) => {
  const actualStationIndex = getActualStationIndex(state, stations);
  const actualStation = actualStationIndex > 0 ? stations[actualStationIndex - 1] : null;
  const nextStation = actualStationIndex < stations.length ? stations[actualStationIndex] : null;
  const currentMcap = Number(state?.currentMcapUsd);
  const liveAvailable = Number.isFinite(currentMcap) && currentMcap >= 0 && state?.status !== 'unavailable';
  return {
    actualStationIndex,
    actualStation,
    nextStation,
    livePressure: getLivePressure(state, stations),
    liveAvailable,
    remainingMcap: liveAvailable && nextStation ? Math.max(0, Number(nextStation.threshold) - currentMcap) : null,
  };
};
